import { generateFilterLocationFromCookie, getCookie } from '@/utils/utils'
import { COOKIES } from '@/utils/constants'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'

export const handleGeolocationValue = ({ cookieNoticeContext, filters }) => {
  const { cookies } = cookieNoticeContext
  const isCookieCategoryActive = cookieCategoryIsActive(
    cookies,
    COOKIES.GEOLOCATION
  )

  const geolocationCookie =
    isCookieCategoryActive && getCookie(COOKIES.GEOLOCATION)
  let geolocationCookieParsed
  if (geolocationCookie && geolocationCookie.substring(0, 1) === '{') {
    geolocationCookieParsed = JSON.parse(geolocationCookie)
  } else {
    geolocationCookieParsed = {
      estadocidade: '',
      localizacao: {
        latitude: undefined,
        longitude: undefined,
        raio: undefined,
      },
    }
  }

  let geolocationValue = null
  let value = ''

  if (geolocationCookieParsed.estadocidade) {
    value = generateFilterLocationFromCookie(
      decodeURIComponent(geolocationCookieParsed.estadocidade)
    )
    geolocationValue = {}
    geolocationValue.estadocidade = value
    geolocationValue.localizacao = geolocationCookieParsed.localizacao
  }

  const { estadocidade: filterLocation = '' } = filters || {}
  const { estadocidade: cookieLocation = '' } = geolocationValue || {}

  if (filterLocation.indexOf('-') > -1 || !(cookieLocation.indexOf('-') > -1)) {
    return ''
  }

  const filterLocationApplyByIP = sessionStorage.getItem(
    'filterLocationApplyByIP'
  )

  if (
    filterLocation &&
    filterLocation !== 'estoque' &&
    !filterLocationApplyByIP
  ) {
    return ''
  }

  const geolocationPermissionType = sessionStorage.getItem(
    'geolocationPermissionType'
  )

  if (filterLocationApplyByIP && geolocationPermissionType === 'granted') {
    sessionStorage.removeItem('filterLocationApplyByIP')
  }

  return { geolocationValue, value }
}
